import React from 'react';

const VIDEOS = [
  { id: 'x1NSQBeBzrU', title: 'How to Tie a Bow Tie' },
  { id: '_f1eeUbs438', title: 'Tie Into Bowtie' },
  { id: 'thGMPoX29Vs', title: 'How to Tie a Knot' },
  { id: 'xjzdhKJXFl4', title: 'Different Types of Knots' },
  { id: 'vFy00ZFDr34', title: '12 Ways to Fold a Pocket Square' },
  { id: 'ZhHA980jRfs', title: "Men's Shirt Collars" },
];

export const VideoTutorials = () => (
  <div className="grid sm:grid-cols-2 gap-6" data-testid="video-tutorials-grid">
    {VIDEOS.map((v) => (
      <div key={v.id} data-testid={`video-card-${v.id}`}>
        <div className="aspect-video rounded-lg overflow-hidden shadow-md border border-gray-200">
          <iframe
            src={`https://www.youtube.com/embed/${v.id}`}
            title={v.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
            className="w-full h-full"
          />
        </div>
        <p className="mt-3 text-base font-semibold text-[#001B2A]">{v.title}</p>
      </div>
    ))}
  </div>
);
